import { render, staticRenderFns } from "./PagarPlazos.vue?vue&type=template&id=28ab4d1b"
import script from "./PagarPlazos.vue?vue&type=script&lang=js"
export * from "./PagarPlazos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports